import { create } from "zustand"
import { persist, createJSONStorage } from "zustand/middleware"

const C_CHAVE_STORAGE = "kanbanFilters"

/** Compara conjuntos de ids de fila ignorando ordem (evita falso "filtro ativo" por reorder). */
const filasIdsConjuntoIgual = (mFilasA = [], mFilasB = []) => {
  const mIdsA = mFilasA.map((q) => q?.id).filter((id) => id !== undefined)
  const mIdsB = mFilasB.map((q) => q?.id).filter((id) => id !== undefined)
  if (mIdsA.length !== mIdsB.length) return false
  const mOrdenadosA = [...mIdsA].sort((a, b) => (a > b ? 1 : a < b ? -1 : 0))
  const mOrdenadosB = [...mIdsB].sort((a, b) => (a > b ? 1 : a < b ? -1 : 0))
  return mOrdenadosA.every((id, i) => id === mOrdenadosB[i])
}

/** Indica se há filtro ativo além do padrão (todas as filas do usuário, sem demais restrições). */
export const filtrosKanbanTemFiltroAtivo = (oFiltros, mFilasUsuario = []) => {
  if (!oFiltros || Object.keys(oFiltros).length === 0) return false

  const mFilasFiltro = oFiltros.queues || []
  const lFilasDiferenteDoPadrao =
    mFilasFiltro.length > 0 &&
    mFilasUsuario.length > 0 &&
    !filasIdsConjuntoIgual(mFilasFiltro, mFilasUsuario)

  return (
    lFilasDiferenteDoPadrao ||
    (oFiltros.users?.length ?? 0) > 0 ||
    (oFiltros.motivo?.length ?? 0) > 0 ||
    (oFiltros.contatos?.length ?? 0) > 0 ||
    oFiltros.lidas === false
  )
}

/** Compatibiliza dados salvos antes da migração para persist do Zustand. */
const oStorageFiltrosKanban = {
  getItem: (cNome) => {
    try {
      const cValor = localStorage.getItem(cNome)
      if (!cValor) return null

      const oParsed = JSON.parse(cValor)
      if (oParsed?.state) return cValor

      return JSON.stringify({
        state: { oFiltros: oParsed || {} },
        version: 1,
      })
    } catch (e) {
      return null
    }
  },
  setItem: (cNome, cValor) => {
    try {
      localStorage.setItem(cNome, cValor)
    } catch (e) {
      // ignore localStorage errors
    }
  },
  removeItem: (cNome) => {
    try {
      localStorage.removeItem(cNome)
    } catch (e) {
      // ignore localStorage errors
    }
  },
}

export const useFiltrosKanbanStore = create(
  persist(
    (set, get) => ({
      oFiltros: {},

      filtrosDefinir: (oFiltros) => set({ oFiltros: oFiltros || {} }),

      limparFiltros: () => set({ oFiltros: {} }),

      filtrosTemFiltroAtivo: (mFilasUsuario = []) => filtrosKanbanTemFiltroAtivo(get().oFiltros, mFilasUsuario),
    }),
    {
      name: C_CHAVE_STORAGE,
      storage: createJSONStorage(() => oStorageFiltrosKanban),
      partialize: (oEstado) => ({ oFiltros: oEstado.oFiltros }),
      version: 1,
      migrate: (oEstadoPersistido) => {
        if (!oEstadoPersistido) return { oFiltros: {} }
        if (oEstadoPersistido.oFiltros) return oEstadoPersistido
        return { oFiltros: oEstadoPersistido }
      },
    },
  ),
)
